<template>
  <WsVersion
    label="稽核公版版本列表"
    :localeMode="true"
    :id="$route.params.id"
    :modelName="modelName"
    :versionModelName="versionModelName"
    :fields="versionFields"
    titleKey="name"
    :showFields="showFields"
    :hideOnNull="hideOnNull"
    :hasExpandList="hasExpandList"
    :subList="subList"
    :hasChapters="hasChapters"
    :sequenceFields="_sequenceFields"
    :editable="editable"
    @getVersionData="$_getVersionData($event)"
  ></WsVersion>
</template>

<script>
import model from "@/models/audit_template";
import submodel from "@/models/audit_question_template";
export default {
  data: () => ({
    modelName: model.modelName,
    versionModelName: model.versionModelName,
    versionFields: model.fields.last_version.fields,
    hideOnNull: false,
    hasExpandList: true,
    hasChapters: true,
    modelData: null,
    editable: true,
    showFields: ["locales", "updated_at", "updated_admin",],
    subList: {
      type: "expandList",
        label: submodel.label,
        modelName: submodel.modelName,
        modeParent: true,
        modeParentVersions: true,
        fields: submodel.fields,
        titleKey: "last_version.title",
        fieldsRead: submodel.fieldsRead,
        fetchWithParams:true,
        searchMode: false,
        isGetAll: false,
    }
  }),
  methods:{
    $_getVersionData($event) {
      if (!$event.tab) {
        this.modelData = $event.versionData[0]
      } else {
        this.modelData = $event.versionData[$event.tab]
      }
    },
  },
  computed:{
    _sequenceFields() {
      if (this.modelData) {
        return this.modelData.chapters;
      } else {
        return null;
      }
    },
    _itemEditable() {
      if (this.modelData) {
        if (this.modelData.last_version) {
          if (!this.modelData.last_version.version_status) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    _itemVersionCreatable() {
      if (this.modelData) {
        if (this.modelData.last_version) {
          if (!this.modelData.last_version.version_status) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    _itemVersionReadable() {
      if (this.modelData) {
        if (this.modelData.last_version) {
          if (!this.modelData.last_version.version_status) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  watch:{
    _itemEditable: function(){
      this.subList.itemEditable = this._itemEditable
    },
    _itemVersionCreatable: function() {
      this.subList.itemVersionCreatable = this._itemVersionCreatable
    },
    _itemVersionReadable: function() {
      this.subList.itemVersionReadable = this._itemVersionReadable
    }
  }
};
</script>

<style>
</style>